import script from "./CreateGroupSurveyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateGroupSurveyDetails.vue?vue&type=script&setup=true&lang=js"

import "./CreateGroupSurveyDetails.vue?vue&type=style&index=0&id=49f6ff88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f6ff88"]])

export default __exports__